import CTARed from './CTARed';
export default CTARed;
